module.exports = __webpack_public_path__ + "img/core-advantages-3.3d1a72ad.svg";